import { actionTypes } from './../../reducers/CCHiFirm/IntegrationFormReducer';
import API from "./../../Constants/cchiFirm/cchiFirmAPI";

export const setFormData = (data) => ({
    type: actionTypes.SET_FORM_DATA,
    payload: data,
});

export const togglePassword = () => ({
    type: actionTypes.TOGGLE_PASSWORD,
});

export const setCanActivate = (canActivate) => ({
    type: actionTypes.SET_CAN_ACTIVATE,
    payload: canActivate,
});

export const setCanSubmit = (canSubmit) => ({
    type: actionTypes.SET_CAN_SUBMIT,
    payload: canSubmit,
});

export const setLoading = (isLoading) => ({
    type: actionTypes.SET_LOADING,
    payload: isLoading,
});

export const setApiMessage = (message) => ({
    type: actionTypes.SET_API_MESSAGE,
    payload: message,
});

export const setSubmitted = (isSubmitted) => ({
    type: actionTypes.SET_SUBMITTED,
    payload: isSubmitted,
});

export const setValidationErrors = (errors) => ({
    type: actionTypes.SET_VALIDATION_ERRORS,
    payload: errors,
});

export const validateForm = (formData) => {
    const errors = {};

    if (formData.domainUrl && !formData.domainUrl.startsWith('https://')) {
        errors.domainUrl = 'Integration URL must start with https://';
    }
    if (formData.domainUrl && formData.domainUrl.endsWith('/')) {
        errors.domainUrl = 'Integration URL cannot contain trailing /';
    }

    if (formData.apiKey && formData.apiKey.length < 6) {
        errors.apiKey = 'Key must be at least 6 characters long';
    }

    return { isValid: Object.keys(errors).length === 0, errors };
};

export const updateFormData = (data) => (dispatch, getState) => {
    dispatch(setFormData(data));

    const state = getState();
    const updatedFormData = { ...state.formData, ...data };
    const { isValid, errors } = validateForm(updatedFormData);

    dispatch(setValidationErrors(errors));
    dispatch(setCanActivate(isValid));
    dispatch(setCanSubmit(isValid));
};

export const fetchFormData = async (dispatch) => {
    dispatch(setLoading(true));
    try {
        const response = await fetch(API.getFirmConfiguration);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const firmConfig = await response.json();
        dispatch(setFormData({
            name: firmConfig?.name || 'CCH iFirm',
            description: firmConfig?.description || 'CCH iFirm - Products/Services',
            domainUrl: firmConfig?.data?.domainUrl || '',
            apiKey: firmConfig?.data?.apiKey || '',
            isFirmIntegrationActive: firmConfig?.data?.isFirmIntegrationActive || false,
        }));
    }
    catch (error) {
        console.error('Error fetching data:', error);
        dispatch(setApiMessage(`We're having trouble processing your request right now. Please try again later.`));
    }
    finally {
        dispatch(setLoading(false));
    }
};

export const submitForm = async (dispatch, formData) => {
    dispatch(setLoading(true));
    dispatch(setApiMessage(''));
    dispatch(setSubmitted(false));

    const { isValid, errors } = validateForm(formData);

    if (!isValid) {
        dispatch(setLoading(false));
        dispatch(setApiMessage('Please correct the validation errors before submitting.'));
        dispatch(setValidationErrors(errors));
        return;
    }

    const payload = {
        domainUrl: formData.domainUrl,
        apiKey: formData.apiKey,
        isFirmIntegrationActive: formData.isFirmIntegrationActive
    };

    try {
        const response = await fetch(API.addFirmConfiguration, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'CSRF-TOKEN': window.localStorage.getItem('CSRF-TOKEN')
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        dispatch(setApiMessage('Your changes are saved successfully'));
        dispatch(setSubmitted(true));
    } catch (error) {
        console.error('Error submitting form:', error);
        dispatch(setApiMessage(`We're having trouble processing your request right now. Please try again later.`));
        dispatch(setSubmitted(false));
    } finally {
        dispatch(setLoading(false));
    }
};